/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing NetworkSecurityPolicy components.
 * @preferred
 * @module NetworkSecurityPolicyModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'ng/shared/shared.module';
import { MatchModule } from 'ng/modules/match/match.module';

import {
    ClrFormsModule,
    ClrInputModule,
    ClrSpinnerModule,
} from '@clr/angular';

import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';
import { RbacModule } from 'ng/modules/rbac/rbac.module';

import {
    NetworkSecurityPolicyListComponent,
    NetworkSecurityPolicyModalComponent,
    NetworkSecurityPolicyRulesGridComponent,
    NetworkSecurityRuleModalComponent,
} from './components';

import {
    geoDbCollectionProvider,
    ipReputationDBCollectionProvider,
    networkSecurityPolicyCollectionProvider,
} from './ajs-upgrade-providers';

const networkSecurityPolicyComponents = [
    NetworkSecurityPolicyListComponent,
    NetworkSecurityPolicyModalComponent,
    NetworkSecurityPolicyRulesGridComponent,
    NetworkSecurityRuleModalComponent,
];

@NgModule({
    declarations: [
        ...networkSecurityPolicyComponents,
    ],
    imports: [
        AviFormsModule,
        ClrSpinnerModule,
        SharedModule,
        ClrFormsModule,
        ClrInputModule,
        CommonModule,
        FormsModule,
        MatchModule,
        RbacModule,
        DataGridModule,
    ],
    providers: [
        geoDbCollectionProvider,
        ipReputationDBCollectionProvider,
        networkSecurityPolicyCollectionProvider,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class NetworkSecurityPolicyModule { }
